import React, { useEffect, useState } from "react";
import { DomainValue } from "../../../../../../services/mdmService/types";
import "./masterData.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomRadio } from "../../../../../../features/salescodeStudio/mandatoryConfigs/optionalFeatures/widget/FearturesInputTypes/FeatureInputs";

interface MasterRenderCardProps {
  index: number;
  groupedMasters: DomainValue[];
  currentMasterGroupName: string;
  setExpandedMasterIndex: React.Dispatch<React.SetStateAction<number | null>>;
  expandedMasterIndex: number | null;
  groupedMandatoryMasters: {
    [key: string]: {
      masters: DomainValue[];
      description: string;
      icon: string;
      multipleOptionMasters?: DomainValue[];
    };
  };
  selectedMaster: DomainValue;
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
}

// Popup Component
const PJPVisitPlanPopup = ({
  onSelectPlan,
  open,
  handleClose,
  selectedMaster,
  setSelectedMaster,
  selectedPlan,
}: {
  onSelectPlan: (plan: string) => void;
  open: boolean;
  handleClose: () => void;
  selectedMaster: DomainValue;
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
  selectedPlan: string;
}) => {
  const handleSelection = (plan: string) => {
    onSelectPlan(plan);
    // handleClose(); // close the popup
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      {/* <DialogTitle>Select PJP Visit Plan</DialogTitle> */}
      <div
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingTop: "10px",
          height: "200px",
          width: "400px",
        }}
      >
        {/* <p>Please choose Weekly or Monthly</p> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            alignItems: "center",
            // marginLeft: "15px",
            // marginRight: "15px",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={(e) => {
              handleClose();
            }}
            sx={{
              color: "#000000",
              paddingRight: "13px",
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "5px",
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#FFFFFF",
              border: "1px solid #00C6B1",

              boxShadow: "0px 0px 8px #0000001A",
              borderRadius: "40px",
            }}
          >
            {/* Icon or image */}
            <img
              src={"https://d2nvw4ekms3xzy.cloudfront.net/salind/images/Group 61598@2x-ioytAXlqXzaS.png"}
              alt="icon"
              style={{ width: "50%" }}
            />
          </div>
        </Box>
        <div
          className="center-text"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h4>What is your PJP Type</h4>
        </div>
        <div style={{ display: "flex", gap: "2vw", justifyContent: "center" }}>
          <CustomRadio
            label="Date Wise"
            value={true}
            checked={selectedPlan === "PJPVisitPlan"}
            onChange={() => handleSelection("PJPVisitPlan")}
            color="#909090"
          />
          <CustomRadio
            label="Week Wise"
            value={false}
            checked={selectedPlan === "PJPVisitPlanV2"}
            onChange={() => handleSelection("PJPVisitPlanV2")}
            color="#909090"
          />
        </div>
      </div>
      <DialogActions style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          sx={{
            color: "#ffffff",
            backgroundColor: "#00C6B1",
            width: "80%",
            marginBottom: "15px",
          }}
          onClick={(e) => {
            handleClose();
          }}
        >
          Continue{" "}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Main Component
export default function MasterRenderCard({
  index,
  groupedMasters,
  currentMasterGroupName,
  setExpandedMasterIndex,
  expandedMasterIndex,
  groupedMandatoryMasters,
  selectedMaster,
  setSelectedMaster,
}: MasterRenderCardProps) {
  const isExpanded = expandedMasterIndex === index;
  const [openPopup, setOpenPopup] = useState(false); // State to control popup visibility
  const [selectedPlan, setSelectedPlan] = useState(""); // State to control popup visibility

  const handlePlanSelection = (plan: string) => {
    console.log("Selected Plan:", plan);
    setSelectedPlan(plan);
    setSelectedMaster(
      groupedMandatoryMasters[
        currentMasterGroupName
      ].multipleOptionMasters?.find((master) => master.id === plan)
    );
  };

  const handlePopupOpen = () => {
    setOpenPopup(true);
  };

  const handlePopupClose = () => {
    setOpenPopup(false);
    setSelectedPlan("")
  };

  return (
    <div className="single-option-card" key={currentMasterGroupName}>
      {groupedMandatoryMasters[currentMasterGroupName] &&
      groupedMandatoryMasters[currentMasterGroupName].masters.length === 1 ? (
        // Display the master directly if there is only one
        <div
          style={{
            backgroundColor:
              selectedMaster &&
              (selectedMaster.id ===
                groupedMandatoryMasters[currentMasterGroupName].masters[0].id ||
                groupedMandatoryMasters[
                  currentMasterGroupName
                ].multipleOptionMasters?.some(
                  (option) => option.id === selectedMaster.id
                ))
                ? "#EAF8F9"
                : "#ffffff",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {
            if (
              groupedMandatoryMasters[currentMasterGroupName]
                .multipleOptionMasters
            ) {
              handlePopupOpen();
            } else {
              setSelectedMaster(
                groupedMandatoryMasters[currentMasterGroupName].masters[0]
              );
            }
            setExpandedMasterIndex(null);
          }}
        >
          <h4>{index + 1}.</h4> {/* Fix index counting */}
          {/* Icon box with rounded boundary */}
          <div
            style={{
              width: "45px",
              height: "45px",
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#FFFFFF",
              border:
                selectedMaster?.id &&
                (selectedMaster.id ===
                  groupedMandatoryMasters[currentMasterGroupName].masters[0]
                    ?.id ||
                  groupedMandatoryMasters[
                    currentMasterGroupName
                  ].multipleOptionMasters?.some(
                    (option) => option.id === selectedMaster.id
                  ))
                  ? "1px solid #00C6B1"
                  : "",
              boxShadow: "0px 0px 8px #0000001A",
              borderRadius: "10px",
            }}
          >
            {/* Icon or image */}
            <img
              src={
                groupedMandatoryMasters[currentMasterGroupName].masters[0]?.icon
              }
              alt="icon"
              style={{ width: "50%" }}
            />
          </div>
          <div className="text-container">
            <h3>{currentMasterGroupName}</h3>
            <h6>
              {groupedMandatoryMasters[currentMasterGroupName].masters[0]
                ?.description ?? ""}
            </h6>
          </div>
        </div>
      ) : (
        // Expansion card for multiple masters
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // padding: "16px",
              backgroundColor: isExpanded ? "#F8FFFF" : "#ffffff",
              cursor: "pointer",
            }}
            onClick={() => {
              setExpandedMasterIndex(isExpanded ? null : index);
            }}
          >
            <div className="group-icon-container">
              <h4>{index + 1}.</h4> {/* Fix index counting */}
              {/* Icon box with rounded boundary */}
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#FFFFFF",
                  border: isExpanded ? "1px solid #00C6B1" : "",
                  boxShadow: "0px 0px 8px #0000001A",
                  borderRadius: "10px",
                }}
              >
                <img
                  src={groupedMandatoryMasters[currentMasterGroupName]?.icon}
                  alt="icon"
                  style={{ width: "60%" }}
                />
              </div>
              <div className="text-container">
                <h3>{currentMasterGroupName}</h3>
                <h6>
                  {groupedMandatoryMasters[currentMasterGroupName]?.description}
                </h6>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div className="spacer" style={{ width: "6px" }}></div>
              {isExpanded ? (
                <FontAwesomeIcon
                  color="#434343"
                  width={"14px"}
                  height={"8px"}
                  icon={faChevronUp}
                />
              ) : (
                <FontAwesomeIcon
                  color="#434343"
                  width={"14px"}
                  height={"8px"}
                  icon={faChevronDown}
                />
              )}
            </div>
          </div>

          {isExpanded && groupedMandatoryMasters[currentMasterGroupName] && (
            <>
              {groupedMandatoryMasters[currentMasterGroupName].masters.map(
                (master, idx) => (
                  <div
                    key={master.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingBlock: "15px",
                      backgroundColor:
                        selectedMaster && selectedMaster.id === master.id
                          ? "#EAF8F9"
                          : "#F8FFFF",
                    }}
                    onClick={() => {
                      setSelectedMaster(master);
                    }}
                  >
                    <div
                      style={{
                        marginLeft:"90px",
                        width: "40px",
                        height: "40px",
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#FFFFFF",
                        border:
                          selectedMaster && selectedMaster.id === master.id
                            ? "1px solid #00C6B1"
                            : "",
                        boxShadow: "0px 0px 8px #0000001A",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src={master?.icon ?? ""}
                        alt="icon"
                        style={{ width: "60%" }}
                      />
                    </div>
                    <div className="text-container">
                      <h5>{`${master.name}`}</h5>
                      <h6>{master?.description}</h6>
                    </div>
                  </div>
                )
              )}
            </>
          )}
        </div>
      )}

      {/* Popup for selecting Weekly or Monthly plan */}
      <PJPVisitPlanPopup
        open={openPopup}
        onSelectPlan={handlePlanSelection}
        handleClose={handlePopupClose}
        selectedMaster={selectedMaster}
        setSelectedMaster={setSelectedMaster}
        selectedPlan={selectedPlan}
      />
    </div>
  );
}
